/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { Controller } from "react-hook-form";
import {
  Flex,
  Button,
  FormControl,
  FormLabel,
  Checkbox,
  Heading,
} from "@chakra-ui/react";
import { MultiSelect } from "@progress/kendo-react-dropdowns";
import FormInput from "../../../components/forms/form-Input";
import {
  CATEGORY_LIST,
  FIXING_SIDE,
  LOADING_SIDE_LIST,
  LOCATION_TYPES,
  SITE_TYPE_LIST,
  STATUS_LIST,
  WEEK_DAYS,
} from "../constants";
import NumericInput from "../../../components/forms/react-hook-numeric-input";
import FormHookDatePicker from "../../../components/forms/form-hook-date-picker";
import ReactHookFormDropdown from "../../../components/forms/react-hook-dropdown";
import {
  useLookupCashCenterRoutes,
  useLookupCities,
  useLookupEmirates,
  useLookupRegions,
} from "../../../services/lookups-mutations";

export default function Information({
  onNextStep,

  cashCenters,
  customerList,
  makersList,
  machineList,
  countriesList,
  onMakerChange,
  modelsList,
  control,
  errors,
  watch,
  handleSubmit,
  setValue,
  reset,
  getValues,
}) {
  const { mutate: getRegions, data: regionsListRes } = useLookupRegions();
  const { mutate: getEmirates, data: emiratesListRes } = useLookupEmirates();
  const { mutate: getCities, data: citiesListRes } = useLookupCities();

  const {
    mutate: getRoute,
    data: routesListRes,
    reset: resetRoutesList,
  } = useLookupCashCenterRoutes();
  useEffect(() => {
    const countryCode = watch("country")?.code;
    if (countryCode && countryCode !== "0") {
      getRegions(countryCode);
      getCities(countryCode);
      getEmirates(countryCode);
    }
  }, [watch("country")]);
  const generalFieldProps = { control, errors };
  const formValidationRules = {
    customerId: { required: "Please Select Customer" },
    cashCenterId: { required: "Please Select Cash Center" },
    locationId: { required: "Please Enter Location Id" },
    locationName: { required: "Please Enter Location Name" },
    locationCode: { required: "Please Enter Location Code" },
    category: { required: "Please Select Category" },
    locationType: { required: "Please Select Location Type" },
    status: { required: "Please Select Status" },
    siteType: { required: "Please Select Site Type" },
    barcode: { required: "Please Enter Barcode" },
    machineSerialNo: { required: "Please Enter Machine Serial No" },
    routeNo: { required: "Please select route" },
    country: { required: "Please select country" },
    city: { required: "Please select city" },
    emirate: { required: "Please select emirate" },
    state: { required: "Please select state" },
  };
  const onCountryChange = () => {
    setValue("state", "");
    setValue("city", "");
    setValue("emirate", "");
  };
  const onCashCenterChange = () => {
    setValue("routeNo", "");
  };
  useEffect(() => {
    if (watch("cashCenterId")?.cashCenterId) {
      resetRoutesList();
      if (watch("cashCenterId").cashCenterId !== "0") {
        getRoute(watch("cashCenterId").cashCenterId);
      }
    }
    if (watch("cashCenterId")?.cashCenterId) {
      getRoute(watch("cashCenterId").cashCenterId);
    }
  }, [watch("cashCenterId")]);

  const submitInfo = (data) => {
    onNextStep(data);
  };

  const onSiteTypeChange = (e) => {
    if (e?.value?.id === "CIT") {
      reset({
        ...getValues(),
        siteType: e.value,
        hasSecurityAlarm: false,
        alarmDetails: "",
        fixingSide: "",
        loadingSide: "",
        machineType: "",
        maker: "",
        model: "",
        lockSerialNo: "",
        machineSerialNo: "",
        maximumCassettes: 0,
        lockInstallationDate: null,
      });
    }
  };
  return (
    <form onSubmit={handleSubmit(submitInfo)}>
      <Flex w="100%" justify="space-between" flexDirection="row">
        <Heading style={{ width: "100%" }}>Information</Heading>
        <Flex w="100%" justify="flex-end" flexDirection="row">
          <Flex
            w="100%"
            justify="flex-end"
            flexDirection="row"
            gap="16px"
            onClick={() => {}}
          >
            <Button type="button" onClick={() => onNextStep()}>
              Next
            </Button>
          </Flex>
        </Flex>
      </Flex>

      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        label="Customer"
        name="customerId"
        id="customerId"
        text="name"
        data={customerList}
        placeholder="Select Customer"
        rules={formValidationRules.customerId}
      />
      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        label="Cash Center"
        name="cashCenterId"
        id="cashCenterId"
        text="name"
        data={cashCenters}
        placeholder="Select Cash Center"
        rules={formValidationRules.cashCenterId}
        onChange={onCashCenterChange}
      />
      <FormInput
        {...generalFieldProps}
        isRequired
        label="Location ID"
        name="locationId"
        rules={formValidationRules.locationId}
      />
      <FormInput
        {...generalFieldProps}
        isRequired
        label="Location Name"
        name="locationName"
        rules={formValidationRules.locationName}
      />
      <FormInput
        {...generalFieldProps}
        isRequired
        label="Location Code"
        name="locationCode"
        rules={formValidationRules.locationCode}
      />
      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        label="Category"
        name="category"
        id="id"
        text="text"
        data={CATEGORY_LIST}
        placeholder="Select Category"
        rules={formValidationRules.category}
      />

      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        label="Route"
        name="routeNo"
        id="routeId"
        text="routeNo"
        data={routesListRes?.data || []}
        placeholder="Select Route"
        rules={formValidationRules.routeNo}
        disabled={!watch("cashCenterId")}
        info={watch("cashCenterId") ? "" : "Select Cash Center To Enable"}
      />
      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        label="Location Type"
        name="locationType"
        id="id"
        text="text"
        data={LOCATION_TYPES || []}
        placeholder="Select Location Type"
        rules={formValidationRules.locationType}
      />

      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        label="Status"
        name="status"
        id="id"
        text="text"
        data={STATUS_LIST || []}
        placeholder="Select Status"
        rules={formValidationRules.status}
      />

      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        label="Site Type"
        name="siteType"
        id="id"
        text="text"
        data={SITE_TYPE_LIST || []}
        placeholder="Select Status"
        rules={formValidationRules.siteType}
        onChange={onSiteTypeChange}
      />

      <FormInput
        {...generalFieldProps}
        isRequired
        label="Barcode"
        name="barcode"
        rules={formValidationRules.barcode}
      />
      <FormInput {...generalFieldProps} label="Site Limit" name="siteLimit" />
      <NumericInput
        {...generalFieldProps}
        label="Distance From Base"
        name="distanceFromBase"
      />
      <NumericInput
        {...generalFieldProps}
        label="Co-Located Group No"
        name="coLocatedGroupNo"
      />

      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        label="Country"
        name="country"
        id="code"
        text="name"
        data={countriesList}
        placeholder="Select Country"
        dropdownProps={{ filterable: true }}
        onChange={onCountryChange}
        rules={formValidationRules.country}
      />
      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        disabled={!watch("country")}
        label="State"
        name="state"
        id="id"
        text="text"
        data={
          regionsListRes?.data.map((elm) => ({
            id: elm.name,
            text: elm.name,
          })) || []
        }
        placeholder="Select State"
        dropdownProps={{ filterable: true }}
        info={!watch("country") ? "Select country To Enable" : ""}
        rules={formValidationRules.state}
      />

      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        disabled={!watch("country")}
        label="City"
        name="city"
        id="id"
        text="text"
        data={
          citiesListRes?.data.map((elm) => ({
            id: elm.name,
            text: elm.name,
          })) || []
        }
        placeholder="Select City"
        dropdownProps={{ filterable: true }}
        info={!watch("country") ? "Select country To Enable" : ""}
        rules={formValidationRules.city}
      />
      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        disabled={!watch("country")}
        label="Emirate"
        name="emirate"
        id="id"
        text="text"
        data={
          emiratesListRes?.data.map((elm) => ({
            id: elm.name,
            text: elm.name,
          })) || []
        }
        placeholder="Select Emirate"
        dropdownProps={{ filterable: true }}
        info={!watch("country") ? "Select country To Enable" : ""}
        rules={formValidationRules.emirate}
      />
      <FormInput {...generalFieldProps} label="Address" name="address" />
      <NumericInput {...generalFieldProps} label="Longitude" name="longitude" />
      <NumericInput {...generalFieldProps} label="Latitude" name="latitude" />

      <FormHookDatePicker
        {...generalFieldProps}
        datePickerProps={{ placeholder: "Select Service Date" }}
        label="First Service Date"
        name="firstServiceDate"
      />
      <FormHookDatePicker
        {...generalFieldProps}
        datePickerProps={{ placeholder: "Select Decommissioned Date" }}
        label="Decommissioned Date"
        name="decomissionedDate"
      />
      <FormControl>
        <FormLabel>Service Days</FormLabel>
        <Controller
          control={control}
          name="serviceDays"
          render={({ field }) => (
            <MultiSelect
              value={field.value}
              data={WEEK_DAYS}
              filterable={false}
              onChange={(e) => {
                field.onChange(e.target.value);
              }}
            />
          )}
        />
      </FormControl>
      <FormControl>
        <FormLabel>Allowed Days</FormLabel>
        <Controller
          control={control}
          name="allowedDays"
          render={({ field }) => (
            <MultiSelect
              value={field.value}
              data={WEEK_DAYS}
              filterable={false}
              onChange={(e) => {
                field.onChange(e.target.value);
              }}
            />
          )}
        />
      </FormControl>
      <div style={{ width: "100%" }} />
      <FormControl>
        <Controller
          control={generalFieldProps.control}
          name="requiresCashierCount"
          render={({ field }) => {
            return (
              <Checkbox isChecked={field.value} onChange={field.onChange}>
                <FormLabel style={{ margin: 0 }}>
                  Requires Cashier Count
                </FormLabel>
              </Checkbox>
            );
          }}
        />
      </FormControl>
      <FormControl>
        <Controller
          control={generalFieldProps.control}
          name="requiresEVhr"
          render={({ field }) => {
            return (
              <Checkbox isChecked={field.value} onChange={field.onChange}>
                <FormLabel style={{ margin: 0 }}>Requires EVhr</FormLabel>
              </Checkbox>
            );
          }}
        />
      </FormControl>

      {watch("siteType")?.id !== "CIT" ? (
        <>
          <FormControl>
            <Controller
              control={generalFieldProps.control}
              name="hasSecurityAlarm"
              render={({ field }) => {
                return (
                  <Checkbox isChecked={field.value} onChange={field.onChange}>
                    <FormLabel style={{ margin: 0 }}>
                      Has Security Alarm
                    </FormLabel>
                  </Checkbox>
                );
              }}
            />
          </FormControl>
          <div style={{ width: "100%" }} />
          <FormInput
            {...generalFieldProps}
            label="Alarm Details"
            name="alarmDetails"
            disabled={!watch("hasSecurityAlarm")}
          />
          <ReactHookFormDropdown
            {...generalFieldProps}
            label="Fixing Side"
            name="fixingSide"
            id="id"
            text="text"
            data={FIXING_SIDE || []}
            placeholder="Select Fixing Side"
          />
          <ReactHookFormDropdown
            {...generalFieldProps}
            label="Loading Side"
            name="loadingSide"
            id="id"
            text="text"
            data={LOADING_SIDE_LIST || []}
            placeholder="Select Loading Side"
          />

          <ReactHookFormDropdown
            {...generalFieldProps}
            label="Machine Type"
            name="machineType"
            id="description"
            text="description"
            data={machineList}
            placeholder="Select Machine Type"
          />

          <ReactHookFormDropdown
            {...generalFieldProps}
            label="Maker"
            name="maker"
            id="name"
            text="name"
            data={makersList}
            placeholder="Select Maker"
            onChange={onMakerChange}
          />
          <ReactHookFormDropdown
            {...generalFieldProps}
            label="Model"
            name="model"
            id="name"
            text="name"
            data={modelsList}
            placeholder="Select Model"
          />

          <FormInput
            {...generalFieldProps}
            label="Lock Serial No"
            name="lockSerialNo"
          />
          <FormInput
            {...generalFieldProps}
            label="Machine Serial No"
            name="machineSerialNo"
            isRequired={watch("siteType")?.id !== "CIT"}
            rules={
              watch("siteType")?.id === "CIT"
                ? {}
                : formValidationRules.machineSerialNo
            }
          />
          <NumericInput
            {...generalFieldProps}
            label="Maximum Cassettes"
            name="maximumCassettes"
          />

          <FormHookDatePicker
            {...generalFieldProps}
            datePickerProps={{ placeholder: "Select Installation Date" }}
            label="Lock Installation Date"
            name="lockInstallationDate"
          />
        </>
      ) : (
        <></>
      )}
      <div style={{ width: "100%" }} />
      <FormControl>
        <Controller
          control={generalFieldProps.control}
          name="followStandardModels"
          render={({ field }) => {
            return (
              <Checkbox isChecked={field.value} onChange={field.onChange}>
                <FormLabel style={{ margin: 0 }}>
                  Follow Standard Models
                </FormLabel>
              </Checkbox>
            );
          }}
        />
      </FormControl>
      <FormControl>
        <Controller
          control={generalFieldProps.control}
          name="followStandardCassettes"
          render={({ field }) => {
            return (
              <Checkbox isChecked={field.value} onChange={field.onChange}>
                <FormLabel style={{ margin: 0 }}>
                  Follow Standard Cassettes
                </FormLabel>
              </Checkbox>
            );
          }}
        />
      </FormControl>
      <FormControl style={{ width: "40%" }}>
        <Controller
          control={generalFieldProps.control}
          name="followStandardDenominations"
          render={({ field }) => {
            return (
              <Checkbox isChecked={field.value} onChange={field.onChange}>
                <FormLabel style={{ margin: 0 }}>
                  Follow Standard Denominations
                </FormLabel>
              </Checkbox>
            );
          }}
        />
      </FormControl>
    </form>
  );
}
